import { useSelector } from 'react-redux';
import { RootState } from '../../store';

/**
 * Hook that returns the area unit label based on the selected country.
 * India: "acres"/"acre", Thailand: "rai"
 */
export const useAreaUnit = (plural = true): string => {
  const countryName = useSelector(
    (state: RootState) => state.country.countryName
  );
  if (countryName === 'Thailand') {
    return 'rai';
  }
  return plural ? 'acres' : 'acre';
};
